import db from '../../plugins/firebase'
import { collection, query, getDocs, addDoc, updateDoc, doc, where } from "firebase/firestore"

const filterAllValores = async (filter) => {
  const valoresRef = collection(db, "valores");
  const params = []
  const valoresList = []
  if(filter && filter.dataInicio && filter.dataInicio != NaN)
    params.push(where("data_vencimento_timestamp", '>', filter.dataInicio))

  if(filter && filter.dataFim && filter.dataFim != NaN)
    params.push(where("data_vencimento_timestamp", '<', filter.dataFim))

  if(filter && filter.isPago)
    params.push(where("isPago", '==', !filter.isPago))

  if(filter && filter.idObra)
    params.push(where("obra.id", '==', filter.idObra))

  console.log(params);
  const q = query(valoresRef, ...params);

  const querySnapshot = await getDocs(q);
  querySnapshot.forEach((doc) => {
    // doc.data() is never undefined for query doc snapshots
    valoresList.push({
      id: doc.id,
      ...doc.data()
    })
  });
  return valoresList
}

const getAllValores = async ()=>{
  const querySnap = await getDocs(query(collection(db, 'valores')));
  const valoresList = []
  querySnap.forEach((doc) => {
    valoresList.push({ id: doc.id, ...doc.data() })
  })
  return valoresList;
}

const deleteValor = async (payload) => {
  const colRef = await doc(db, 'valores', payload.id);
  await updateDoc(colRef, {
    ...payload,
    active: false
  });
}

const saveValor = async (payload) => {
  const colRef = collection(db, 'valores')
  await addDoc(colRef, payload)
}

const updateValor = async (payload) => {
  const colRef = await doc(db, 'valores', payload.id);
  await updateDoc(colRef, payload);
}

export { filterAllValores, getAllValores, saveValor, updateValor, deleteValor }
